import React, { useState, useEffect } from "react";

const ChirpStackStep2 = ({ devices, onComplete, onBack }) => {
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [existingDevices, setExistingDevices] = useState(new Set());

  useEffect(() => {
    checkExistingDevices();
  }, [devices]);

  const checkExistingDevices = async () => {
    try {
      const response = await fetch("/api/admin/sensoren", {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      if (response.ok) {
        const data = await response.json();
        const existing = new Set(data.map(sensor => sensor.device_id));
        setExistingDevices(existing);
      }
    } catch (error) {
      console.error("Fout bij ophalen bestaande sensoren:", error);
    }
  };

  const handleDeviceToggle = (device) => {
    const isSelected = selectedDevices.some(d => d.devEui === device.devEui);
    
    if (isSelected) {
      setSelectedDevices(selectedDevices.filter(d => d.devEui !== device.devEui));
    } else {
      setSelectedDevices([...selectedDevices, device]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedDevices([]);
      setSelectAll(false);
    } else {
      const availableDevices = devices.filter(device => !existingDevices.has(device.devEui));
      setSelectedDevices(availableDevices);
      setSelectAll(true);
    }
  };

  const handleContinue = () => {
    if (selectedDevices.length > 0) {
      onComplete(selectedDevices);
    }
  };

  const availableDevices = devices.filter(device => !existingDevices.has(device.devEui));
  const existingCount = devices.length - availableDevices.length;

  return (
    <div>
      <h4>Stap 2: Devices Selecteren</h4>
      <p>Kies welke devices je wilt importeren als sensoren.</p>

      <div className="row">
        <div className="col-md-6">
          <div className="info-box">
            <span className="info-box-icon bg-blue"><i className="fa fa-list"></i></span>
            <div className="info-box-content">
              <span className="info-box-text">Totaal gevonden</span>
              <span className="info-box-number">{devices.length}</span>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="info-box">
            <span className="info-box-icon bg-green"><i className="fa fa-check"></i></span>
            <div className="info-box-content">
              <span className="info-box-text">Beschikbaar</span>
              <span className="info-box-number">{availableDevices.length}</span>
            </div>
          </div>
        </div>
      </div>

      {existingCount > 0 && (
        <div className="alert alert-warning">
          <i className="fa fa-warning"></i> <strong>Let op:</strong> {existingCount} device(s) bestaan al als sensor en worden niet getoond.
        </div>
      )}

      {availableDevices.length === 0 ? (
        <div className="alert alert-info">
          <strong>Geen nieuwe devices beschikbaar.</strong>
          <br />
          Alle gevonden devices zijn al geïmporteerd als sensoren.
        </div>
      ) : (
        <div>
          <div className="row">
            <div className="col-md-6">
              <div className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                  <strong>Selecteer alle beschikbare devices ({availableDevices.length})</strong>
                </label>
              </div>
            </div>
            <div className="col-md-6 text-right">
              <span className="badge bg-blue">
                {selectedDevices.length} geselecteerd
              </span>
            </div>
          </div>

          <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
            <table className="table table-bordered table-hover">
              <thead style={{ position: "sticky", top: 0, backgroundColor: "#f7f7f7" }}>
                <tr>
                  <th width="50">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th>Device EUI</th>
                  <th>Naam</th>
                  <th>Beschrijving</th>
                  <th>Tags</th>
                  <th>Application</th>
                </tr>
              </thead>
              <tbody>
                {availableDevices.map((device, index) => {
                  const isSelected = selectedDevices.some(d => d.devEui === device.devEui);
                  
                  return (
                    <tr key={index} className={isSelected ? "success" : ""}>
                      <td>
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => handleDeviceToggle(device)}
                        />
                      </td>
                      <td><code>{device.devEui}</code></td>
                      <td>{device.name || <em className="text-muted">Geen naam</em>}</td>
                      <td>{device.description || <em className="text-muted">Geen beschrijving</em>}</td>
                      <td>
                        {device.tags && Object.keys(device.tags).length > 0 ? (
                          <div className="tags-display">
                            {Object.entries(device.tags).map(([key, value], tagIndex) => (
                              <span key={tagIndex} className="badge badge-info mr-1 mb-1" style={{ fontSize: '0.75em' }}>
                                {key}: {value}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span className="text-muted">Geen tags</span>
                        )}
                      </td>
                      <td>{device.applicationId || "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-md-6">
          <button className="btn btn-default" onClick={onBack}>
            <i className="fa fa-arrow-left"></i> Terug
          </button>
        </div>
        <div className="col-md-6 text-right">
          {selectedDevices.length > 0 && (
            <button className="btn btn-primary btn-lg" onClick={handleContinue}>
              Configureren ({selectedDevices.length} devices) <i className="fa fa-arrow-right"></i>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChirpStackStep2;